import { InspectionConclusionEnum } from "commons/enum/inspection";
import { Instance, SnapshotIn, types } from "mobx-state-tree";
import { withSetPropAction } from "mobx-stores/_extension/with-set-props";
import { Base, IBaseProperties } from "mobx-stores/_models/base";
import { Product } from "mobx-stores/_models/products/product";

export const DualLangInspectionNoteItem = types
  .compose(
    Base,
    types.model({
      productId: types.maybeNull(types.string),
      product: types.maybeNull(Product),
      appearanceInspectionStandard: types.maybeNull(types.string),
      inspector: types.maybeNull(types.string),
      // Materials
      paperTypeInspect: types.maybeNull(types.number),
      paperTypeResult: types.enumeration<InspectionConclusionEnum>(
        "paperTypeResult",
        Object.values(InspectionConclusionEnum)
      ),

      thicknessInspect: types.maybeNull(types.number),
      thicknessResult: types.enumeration<InspectionConclusionEnum>(
        "thicknessResult",
        Object.values(InspectionConclusionEnum)
      ),

      weightInspect: types.maybeNull(types.number),
      weightResult: types.enumeration<InspectionConclusionEnum>(
        "weightResult",
        Object.values(InspectionConclusionEnum)
      ),

      // Dimensions
      lengthInspect: types.maybeNull(types.number),
      lengthResult: types.enumeration<InspectionConclusionEnum>(
        "lengthResult",
        Object.values(InspectionConclusionEnum)
      ),

      widthInspect: types.maybeNull(types.number),
      widthResult: types.enumeration<InspectionConclusionEnum>(
        "widthResult",
        Object.values(InspectionConclusionEnum)
      ),

      heightInspect: types.maybeNull(types.number),
      heightResult: types.enumeration<InspectionConclusionEnum>(
        "heightResult",
        Object.values(InspectionConclusionEnum)
      ),

      // Standards
      approvalInspect: types.maybeNull(types.string),
      approvalResult: types.enumeration<InspectionConclusionEnum>(
        "approvalResult",
        Object.values(InspectionConclusionEnum)
      ),

      printColorInspect: types.maybeNull(types.string),
      printColorResult: types.enumeration<InspectionConclusionEnum>(
        "printColorResult",
        Object.values(InspectionConclusionEnum)
      ),

      appearanceInspect: types.maybeNull(types.string),
      appearanceResult: types.enumeration<InspectionConclusionEnum>(
        "appearanceResult",
        Object.values(InspectionConclusionEnum)
      ),
      otherStandardInspect: types.maybeNull(types.string),
      otherStandardResult: types.enumeration<InspectionConclusionEnum>(
        "otherStandardResult",
        Object.values(InspectionConclusionEnum)
      ),

      // Final Conclusion
      conclusion: types.maybeNull(types.string),
    })
  )
  .actions(withSetPropAction);
export interface IDualLangInspectionNoteItem
  extends Instance<typeof DualLangInspectionNoteItem> {}
export interface IDualLangInspectionNoteItemProperties
  extends SnapshotIn<typeof DualLangInspectionNoteItem> {}

export interface ExtraPropertiesForDisplay {
  paperType: string;
  paperTypeInspecctionStandard: string;
  thickness: string;
  thicknessStandard: string;
  weight: string;
  weightStandard: string;
  length: string;
  lengthStandard: string;
  width: string;
  widthStandard: string;
  height: string;
  heightStandard: string;
  approval: string;
  approvalStandard: string;
  printColor: string;
  printColorStandard: string;
  otherStandard: string;
  apperance: string;
  otherStandardInspectionStandard: string;
}
export interface IAddEditDualLangInspectionNoteItem
  extends ExtraPropertiesForDisplay,
    Omit<IDualLangInspectionNoteItemProperties, "product"> {}
export interface IAddDualLangInspectionNoteItem
  extends Omit<IAddEditDualLangInspectionNoteItem, keyof IBaseProperties> {}
export interface IUpdateDualLangInspectionNoteItem
  extends ExtraPropertiesForDisplay,
    Omit<IDualLangInspectionNoteItemProperties, "product"> {}
